export default __webpack_public_path__ + "static/media/computer_work.9e43456f.jpg";